import React from 'react';
import { Reveal } from './Reveal';
import { SlideFrame } from './SlideFrame';
const route = ['Aisle', 'Poll', 'Peer result', 'Booth'];
const moments = [{
  number: '01',
  title: 'Aisle breaker',
  copy: 'Takeda staff approach delegates with a simple, engaging opening — not a product pitch.',
  prompt: '“Want to see how your view compares with your peers?”'
}, {
  number: '02',
  title: 'Peer-poll',
  copy: 'The same question becomes a live congress pulse, giving immediate peer perspective and creating curiosity.'
}, {
  number: '03',
  title: 'Booth entry',
  copy: 'The HCP arrives already engaged, already thinking and already part of the narrative.'
}];
export function AisleToConversationSlide() {
  return <SlideFrame topBand eyebrow="The intermission that isn’t" data-id="element-61" data-mp="28dti60sif840">
      <header className="flex items-end justify-between gap-[5vw]" data-id="element-62" data-mp="bi48a7rpgnld">
        <h1 className="max-w-[13ch] font-display text-[clamp(50px,6.7vw,110px)] font-bold leading-[0.94] tracking-[-0.03em]" data-id="element-63" data-mp="6jucbuy5piyp">
          From aisle to conversation
        </h1>
        <p className="mb-[0.8vh] max-w-[25ch] font-display text-[clamp(20px,2vw,34px)] font-medium leading-[1.12] text-black/55" data-id="element-64" data-mp="20d6cbtflxfr5">
          The booth conversation should begin before the booth.
        </p>
      </header>

      <div className="relative mt-[3.5vh] px-[1vw] py-[1.7vh]" data-id="element-65" data-mp="1rbydna96icwj">
        <div className="absolute left-[4%] right-[4%] top-1/2 h-[clamp(3px,0.3vw,5px)] -translate-y-1/2 bg-[#D62B22]" data-id="element-66" data-mp="1rekobird98iz" />
        <div className="relative z-10 grid grid-cols-4" data-id="element-67" data-mp="2k15kqxmp8ate">
          {route.map((stop, index) => <div key={stop} className="flex items-center" data-id="element-68" data-mp="25ciy0auqsgs5" data-mpi={index}>
              <span className="flex size-[clamp(30px,3vw,54px)] items-center justify-center rounded-full border-[clamp(2px,0.25vw,4px)] border-[#D62B22] bg-[#F4F1E8] font-sans text-[clamp(10px,0.75vw,14px)] font-bold text-[#D62B22]" data-id="element-69" data-mp="25bzeippg1kc0">0{index + 1}</span>
              <p className="ml-[0.8vw] bg-[#F4F1E8] pr-[1vw] font-display text-[clamp(18px,1.75vw,31px)] font-semibold" data-id="element-70" data-mp="32s58jvigjel3">{stop}</p>
            </div>)}
        </div>
      </div>

      <div className="mt-[2.5vh] grid min-h-0 flex-1 grid-cols-3 border-y border-black/20" data-id="element-71" data-mp="37oixvt2fmmc5">
        {moments.map((moment, index) => <Reveal key={moment.title} delay={0.06 + index * 0.06} className={`py-[2.2vh] ${index > 0 ? 'border-l border-black/15 pl-[2vw]' : ''} ${index < moments.length - 1 ? 'pr-[2vw]' : ''}`} data-id="element-72" data-mp="32oek4asws5pm" data-mpi={index}>
            <span className="font-sans text-[clamp(10px,0.8vw,15px)] font-semibold tracking-[0.12em] text-[#D62B22]" data-id="element-73" data-mp="2tpt1ygrcmspd">{moment.number}</span>
            <h2 className="mt-[0.7vh] font-display text-[clamp(22px,2.2vw,39px)] font-semibold leading-none" data-id="element-74" data-mp="2ovyc0vl5hhhu">{moment.title}</h2>
            <p className="mt-[1.3vh] max-w-[31ch] font-sans text-[clamp(12px,1vw,18px)] leading-snug text-black/55" data-id="element-75" data-mp="2f0509ef99s14">{moment.copy}</p>
            {moment.prompt ? <p className="mt-[1.5vh] border-t-[clamp(2px,0.22vw,4px)] border-[#D62B22] pt-[1.2vh] font-display text-[clamp(16px,1.45vw,26px)] font-medium leading-[1.12] text-black/75" data-id="element-76" data-mp="2b0cpcv2e39sl">{moment.prompt}</p> : null}
          </Reveal>)}
      </div>

      <p className="mt-[2.2vh] font-display text-[clamp(26px,2.8vw,49px)] font-semibold leading-none" data-id="element-77" data-mp="qf6azlwfl965">
        The poll is not a side activity. <span className="text-[#D62B22]" data-id="element-78" data-mp="ufq3gc627oly">It is the doorway to the conversation.</span>
      </p>
    </SlideFrame>;
}